(function () {
  if (window.__ctrCtaInit) return;
  window.__ctrCtaInit = true;

  function handleScrollAtc(event) {
    var btn = event.target.closest('[data-ctr-scroll-atc]');
    if (!btn) return;
    event.preventDefault();
    var atcBtn = document.querySelector(
      '.ctr-main-product-v2__atc-btn, .ctr-main-product__atc-btn'
    );
    if (!atcBtn) return;
    atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    atcBtn.focus({ preventScroll: true });
  }

  document.addEventListener('click', handleScrollAtc);
})();
